import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useRefFrom } from "@faire/web--source/ui/hooks/useRefFrom";
import * as React from "react";
import { AbortNotifier } from "../userPerceivedLoadTiming/AbortNotifier";
import { waitForImagesToLoad } from "../userPerceivedLoadTiming/waitForImagesToLoad";
var DEFAULT_IMAGE_LOADING_TIMEOUT = 5000;
export var useWaitForImagesToLoad = function(options) {
    var optionsRef = React.useRef(options);
    optionsRef.current = options;
    var mountTimerId = React.useRef(undefined);
    var _useRefFrom = useRefFrom(function() {
        return new AbortNotifier();
    }), notifier = _useRefFrom.current;
    React.useEffect(function() {
        return function() {
            // cleanup image listeners on unmount
            notifier.abort();
        };
    }, [
        notifier
    ]);
    var elementListRef = React.useRef([]);
    var startWaitForImagesToLoad = function() {
        var elementList = elementListRef.current;
        waitForImagesToLoad(elementList, notifier, function(numImagesPending, totalNumImages) {
            return optionsRef.current.onImageLoad(numImagesPending, totalNumImages);
        }, optionsRef.current.shouldIncludeAllImages).finally(function() {
            optionsRef.current.onImageLoad(0, 0);
            notifier.abort();
        });
    };
    React.useEffect(function() {
        if (elementListRef.current.length >= options.numComponents) {
            startWaitForImagesToLoad();
        }
    }, [
        options.numComponents
    ]);
    return React.useCallback(function(element) {
        if (element) {
            var _optionsRef_current = optionsRef.current, numComponents = _optionsRef_current.numComponents, onTimeout = _optionsRef_current.onTimeout;
            if (mountTimerId.current === undefined) {
                var _optionsRef_current_timeout;
                mountTimerId.current = getWindowOrThrow().setTimeout(function() {
                    onTimeout === null || onTimeout === void 0 ? void 0 : onTimeout();
                    notifier.abort();
                }, (_optionsRef_current_timeout = optionsRef.current.timeout) !== null && _optionsRef_current_timeout !== void 0 ? _optionsRef_current_timeout : DEFAULT_IMAGE_LOADING_TIMEOUT);
                notifier.addAbortListener(function() {
                    clearTimeout(mountTimerId.current);
                });
            }
            var elementList = elementListRef.current;
            elementList.push(element);
            if (elementList.length === numComponents) {
                startWaitForImagesToLoad();
            }
        }
    }, [
        notifier
    ]);
};
